import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import {Router} from "@angular/router"
import { B2cService } from "../services/b2c/b2c.service";
import { UserService } from "../services/user/user.service";
@Component({
  selector: 'app-b2c-commande',
  templateUrl: './b2c-commande.component.html',
  styleUrls: ['./b2c-commande.component.css']
})
export class B2cCommandeComponent implements OnInit {
  pageName = 'commandes'
  produits:any;
  total = 0;
  constructor(private route: ActivatedRoute,private router:Router,private b2cService:B2cService,private userService:UserService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.userService.getCommande(params.get('id')).subscribe(res=>{
        this.produits = res["data"];
        this.produits.forEach(produit => {
          this.total += parseInt(produit.NETPRI);
        });
      })
    })
  }


  logout(){
    localStorage.removeItem('user')
    localStorage.removeItem('typeCompte')
    this.router.navigate(['/']);
  }

}
